import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { ToasterModule } from 'angular2-toaster';

import { Store } from '@ngrx/store';
import { BlockUIService } from 'ng-block-ui';
import { XHRBackend, RequestOptions, Http } from '@angular/http';
import { customHttpFactory } from './customHttp.service';
import { FileSaverModule } from 'ngx-filesaver';

import { AuthenticationModule } from '../authentication/authentication.module';
import { SharedModule } from '../shared/shared.module';
import { StageModule } from '../stage/stage.module';

import './rxjs.imports';
import { routing } from './app.routes';
import { ApplicationComponent } from './containers/application/application.component';
import { NgZone } from '@angular/core';

import { Ng2ImgToolsModule } from "ng2-img-tools";
import { Ng2ImgMaxModule } from 'ng2-img-max';

declare var require: any;
import '../modernizr.js';

@NgModule({
  declarations: [
    ApplicationComponent
  ],
  imports: [
    BrowserModule,
    ToasterModule,
    BrowserAnimationsModule ,
    FileSaverModule,
      Ng2ImgToolsModule,
      Ng2ImgMaxModule,
    SharedModule,
    AuthenticationModule,
    StageModule,
    routing
  ],
  providers: [
    {
      provide: Http,
      useFactory: customHttpFactory,
      deps: [XHRBackend, RequestOptions, Store, NgZone, BlockUIService]
    }
  ],
  exports: [ApplicationComponent],
  bootstrap: [ApplicationComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/application/app.module.ts